import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bs-ng-invalid-feedback',
  templateUrl: './bs-ng-invalid-feedback.component.html',
})
export class BsNgInvalidFeedbackComponent implements OnInit {
  @Input() form: AbstractControl;
  @Input() error: string;
  @Input() key: string;
  @Input() identifier = '';

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    if (!this.identifier) {
      throw new Error('Input "identifier" is required for <app-bs-ng-invalid-feedback>.');
    }
  }

  get hasFeedbackError(): boolean {
    return (
      this.form.errors &&
      (this.form.errors as any)[this.error] &&
      (this.form.errors as any)[this.error] != null
    );
  }

  get feedbackErrorMessage(): string {
    const angularValidationMessageKeys: Record<string, string> = {
      minlength: 'minLengthErrorMessage',
      maxlength: 'maxLengthErrorMessage',
    };
    const messageKey =
      angularValidationMessageKeys[this.error] ||
      (this.error.endsWith('Error')
        ? `${this.error}Message`
        : `${this.error}ErrorMessage`);

    return this.translateService.instant(`${this.key}.${messageKey}`);
  }

  get touched(): boolean {
    return this.form.touched;
  }
}
